/** Subscription feature codes for primary nav gating (align with backend subscription features). */
export const APP_NAV_FEATURE_CODES = {
  primeArtifacts: 'prime_artifacts',
  artifactConfiguration: 'artifact_configuration',
} as const;

export type AppNavFeatureCode = (typeof APP_NAV_FEATURE_CODES)[keyof typeof APP_NAV_FEATURE_CODES];
